module.exports = __webpack_public_path__ + "static/phones-2fe3ea2b2dfa0c9094b9dd2f9ee78ea0.png";